import Vue from 'vue'
import Vant, { Locale } from 'vant'
// import 'vant/lib/index.css'
import 'vant/lib/index.less';
// import '@/vant-variables.less'
import { Lazyload } from 'vant';
Vue.use(Vant)
Vue.use(Lazyload);